import { render, staticRenderFns } from "./UserMailboxAside.vue?vue&type=template&id=457b4a46&scoped=true&"
import script from "./UserMailboxAside.vue?vue&type=script&lang=js&"
export * from "./UserMailboxAside.vue?vue&type=script&lang=js&"
import style0 from "./UserMailboxAside.vue?vue&type=style&index=0&id=457b4a46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457b4a46",
  null
  
)

export default component.exports